export default __webpack_public_path__ + "static/media/savage-nation-app-icon.abacc20d.png";